import { Tabs } from "antd";
import { useEffect, useState } from "react";
import { RepairProductInfoForm } from "./Product";
import { RepairReservationInfoForm } from "./Reservation";
import { TabContent, TabStyled } from "./index.styled";
import useReservation from "../../../../hooks/useReservation";

export interface TabMenuProps {
  id: string;
  name: React.ReactNode;
  comp: JSX.Element | string;
  disabled?: boolean;
}

interface TabLayoutFormProps {}

export const TabLayoutForm: React.FC<TabLayoutFormProps> = () => {
  const [menu, setMenu] = useState<TabMenuProps[]>([]);
  const { reservation } = useReservation();

  useEffect(() => {
    const list: TabMenuProps[] = [
      {
        id: "reservation",
        name: "예약정보",
        comp: <RepairReservationInfoForm repairNo={reservation.repairNo} />,
      },
      {
        id: "product",
        name: "출고정보",
        comp: <RepairProductInfoForm repairNo={reservation.repairNo} />,
      },
    ];
    setMenu(list);
  }, [reservation]);

  return (
    <TabStyled
      defaultActiveKey="reservation"
      tabBarGutter={16}
      tabBarStyle={{
        padding: "0 24px",
        marginBottom: 0,
        fontSize: 17,
        lineHeight: "24px",
      }}
    >
      {menu?.map((tab) => (
        <Tabs.TabPane
          key={tab.id}
          id={tab.id}
          tab={tab.name}
          disabled={tab.disabled}
        >
          <TabContent>{tab.comp}</TabContent>
        </Tabs.TabPane>
      ))}
    </TabStyled>
  );
};
